import { defineStore } from 'pinia';
import axios from 'axios';

// Courses admin store (Feature 2). Mirrors useGradeStore conventions:
// talks to the /admin/courses endpoints and unwraps the {status,data} envelope.
export const useCourseStore = defineStore('courses', {
    state: () => ({
        courses: [],
        loading: false,
        saving: false,
    }),

    actions: {
        async fetchCourses() {
            this.loading = true;
            try {
                const { data } = await axios.get('/admin/courses');
                this.courses = data.data ?? [];
            } finally {
                this.loading = false;
            }
        },

        // payload is a FormData instance (supports image / cover_image uploads).
        async createCourse(payload) {
            this.saving = true;
            try {
                const { data } = await axios.post('/admin/courses', payload);
                this.courses.push(data.data);
                return data.data;
            } finally {
                this.saving = false;
            }
        },

        async updateCourse(id, payload) {
            this.saving = true;
            try {
                // POST fallback route accepts multipart updates (Laravel can't parse
                // multipart on PUT); backend maps both to CourseController@update.
                const { data } = await axios.post(`/admin/courses/${id}`, payload);
                this.replaceLocal(data.data);
                return data.data;
            } finally {
                this.saving = false;
            }
        },

        async toggleVisible(id) {
            const { data } = await axios.patch(`/admin/courses/${id}/toggle-visible`);
            this.replaceLocal(data.data);
            return data.data;
        },

        async toggleSubscription(id) {
            const { data } = await axios.patch(`/admin/courses/${id}/toggle-subscription`);
            this.replaceLocal(data.data);
            return data.data;
        },

        async deleteCourse(id) {
            await axios.delete(`/admin/courses/${id}`);
            this.courses = this.courses.filter(c => c.id !== id);
        },

        replaceLocal(course) {
            const idx = this.courses.findIndex(c => c.id === course.id);
            if (idx !== -1) this.courses[idx] = course;
        },
    },
});
